<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-card class='mx-4 my-4'>
                    <v-card-title>
                        <h3 class="text-left mx-4 my-3">{{ is_editing? `Classroom: ${classroom.sections}` : 'Add Classroom' }}</h3>
                    </v-card-title>
                    <v-form v-model="submitForm" @submit.prevent ref="addEditClassroomForm">
                        <v-row class="mx-4" v-if="this.sectionFormat == 1">
                            <v-col cols="12" md="4">
                                <v-combobox
                                outlined
                                dense
                                class="rounded-input mx-1"
                                :items="sections.filter(x => x.section_class == 1)"
                                placeholder="eg. 1st"
                                item-text="title"
                                :rules="[rules.required]"
                                v-model="standard"
                                label="Standard"
                                :error-messages="errors.classroomError"
                                maxlength="25"
                                @change="checkClassroomExists()"
                                counter
                                ></v-combobox>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-combobox
                                outlined
                                dense
                                :items="sections.filter(x => x.section_class == 2)"
                                class="rounded-input mx-1"
                                item-text="title"
                                :rules="[rules.required]"
                                v-model="division"
                                placeholder="eg. 1st"
                                label="Division"
                                maxlength="25"
                                :error-messages="errors.classroomError"
                                @change="checkClassroomExists()"
                                counter
                                ></v-combobox>
                            </v-col>
                        </v-row>
                        <v-row class="mx-4" v-if="this.sectionFormat == 2">
                            <v-col cols="12" md="4">
                                <v-combobox
                                outlined
                                dense
                                :items="sections.filter(x => x.section_class == 3)"
                                class="rounded-input mx-1"
                                placeholder="eg. 1st"
                                item-text="title"
                                v-model="batch"
                                :rules="[rules.required]"
                                label="Batch"
                                maxlength="25"
                                :error-messages="errors.classroomError"
                                @change="checkClassroomExists()"
                                counter
                                ></v-combobox>
                            </v-col>
                        </v-row>
                        <v-row class="mx-4" v-if="this.sectionFormat == 3">
                            <v-col cols="12" md="4">
                                <v-combobox
                                outlined
                                dense
                                class="rounded-input mx-1"
                                :items="sections.filter(x => x.section_class == 4)"
                                placeholder="eg. 1st"
                                item-text="title"
                                v-model="year"
                                :rules="[rules.required]"
                                label="Year"
                                maxlength="25"
                                :error-messages="errors.classroomError"
                                @change="checkClassroomExists()"
                                counter
                                ></v-combobox>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-combobox
                                outlined
                                dense
                                class="rounded-input mx-1"
                                :items="sections.filter(x => x.section_class == 5)"
                                placeholder="eg. 1st"
                                label="Department"
                                v-model="department"
                                item-text="title"
                                :rules="[rules.required]"
                                maxlength="25"
                                :error-messages="errors.classroomError"
                                @change="checkClassroomExists()"
                                counter
                                ></v-combobox>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-combobox
                                outlined
                                dense
                                class="rounded-input mx-1"
                                :items="sections.filter(x => x.section_class == 2)"
                                placeholder="eg. 1st"
                                label="Division"
                                v-model="division"
                                item-text="title"
                                :rules="[rules.required]"
                                maxlength="25"
                                :error-messages="errors.classroomError"
                                @change="checkClassroomExists()"
                                counter
                                ></v-combobox>
                            </v-col>
                        </v-row>
                        <v-row class="mx-4">
                            <v-col cols="12" md="4">
                                <v-text-field :rules="[rules.classroom_number]" v-model="classroom.room_no" class="rounded-input mx-1" dense outlined label="Room Number"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <!-- <v-spacer></v-spacer> -->
                            <v-col>
                                <div class="mx-4">
                                    <v-btn v-if="is_editing" class="mr-4" color="red" rounded outlined :to="{ name:'ClassroomDetails', params: { id: this.classroom.id } }">Cancel</v-btn>
                                    <v-btn v-else class="mr-4" color="red" rounded outlined :to="{ name:'ClassroomRecord'}">Cancel</v-btn>
                                    <v-btn color="primary" type="submit" :disabled="isLoading || !submitForm" @click="addRoom()" rounded>Submit</v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
        <v-card class='mx-4 my-3' v-if="is_editing">
            <v-card-title class="pb-0">
                <h3 class="text-left mx-4 my-4">Subjects</h3>
            </v-card-title>
            <div v-if="currentUser.privileges.canViewClassroomSubjects" class="mx-4 text-left">
                <v-expansion-panels
                    v-model="panel"
                    multiple
                    focusable
                >
                    <v-expansion-panel v-for="subject in subjects" :key="subject.id" class=" mb-1">
                        <v-expansion-panel-header class="py-1 pl-2">
                            <v-list-item class="my-0">
                                <v-list-item-avatar color="primary" size="36" rounded>
                                    <span class="white--text px-1 font-weight-bold">{{ subject.name.slice(0,2) }}</span>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <h3>{{ subject.name }}</h3>
                                </v-list-item-content>
                            </v-list-item>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="pb-0">
                            <v-row>
                                <v-col cols="12" class="pb-0 bold">
                                    <p class="mb-0">Subject Code : <b> {{ subject.code || "-" }}</b> </p>
                                </v-col>
                                <v-col cols="12">
                                    <p class="my-4 mb-1 text-left">Assigned Teachers :</p>
                                    <v-combobox
                                        v-model="subject.faculty"
                                        :items="faculty"
                                        disabled
                                        chips
                                        clearable
                                        label="Assigned Teachers"
                                        class="mb-0"
                                        multiple
                                        item-text="full_name"
                                        item-value="id"
                                        hide-details
                                        solo
                                    >
                                        <template v-slot:selection="{ attrs, item, select, selected }">
                                        <v-chip
                                            v-bind="attrs"
                                            :input-value="selected"
                                            @click="select"
                                            color="primary"
                                            outlined
                                        >
                                            <strong>{{ item.full_name }}</strong>
                                        </v-chip>
                                        </template>
                                    </v-combobox>
                                </v-col>
                                <v-col cols="12" class="text-center">
                                    <AddEditSubject :faculty="faculty" :room="classroom" @saveSubject="getClassRoomSubjects" @discardChanges="getClassRoomSubjects" :isEditing="true" :subject="subject" />
                                    <v-btn v-if="currentUser.privileges.canDeleteClassroomSubjects" outlined rounded color="red" class="mx-2" @click="deleteSubject(subject)">Delete Subject</v-btn>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <div class="text-center">
                    <AddEditSubject :faculty="faculty" :room="classroom" @saveSubject="appendSubject"/>
                </div>

            </div>
        </v-card>

        <DeleteConfirmationDialog 
            :visible="showDeleteConfirmationDialog"
            :title="`Are you sure you want to delete this Subject`"
            description="You cannot undo this action"
            @deleteObject="deleteSelectedClassroom"
        />
        <v-snackbar v-model="snackbar.visible" :color="snackbar.color" multi-line>
            {{ snackbar.message }}
            <template v-slot:action="{ attrs }">
                <v-btn dark text v-bind="attrs" @click="snackbar.visible = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>    
</template>

<script>
import api from "@api/index"
import { mapActions, mapGetters } from "vuex"
import endpoints from "@api/repository"
import AddEditSubject from "@components/classrooms/AddEditSubject";
import DeleteConfirmationDialog from '@components/widgets/dialogs/DeleteConfirmationDialog';
import Helper from "@utils/misc"
export default {
    name: "AddClassroom",
    components: {
        AddEditSubject,
        DeleteConfirmationDialog,
    },
    computed: {
        ...mapGetters([
            "currentUser",
            "accessToken",
            "isLoading",
            "currentInstitution",
        ]),

        apiEssentials() {
            return {
                accessToken: this.accessToken,
                setLoading: this.setLoading,
                handleErrorsFunction: this.handleApiErrors,
            };
        },
    },
    data(){
        return {
            rules: {
                classroom_number: (v) => /^[a-zA-Z0-9]{0,10}$/.test(v) || "Invalid Name",
                required: (value) => !!value || "Required",
            },
            snackbar: {
				visible: false,
				message: "",
				color: "dark",
			},
            is_editing: false,
            sectionCategories: [],
            sectionFormat: null,
            sections: [],
            submitForm: false,
            standard: null,
            division: null,
            batch: null,
            year: null,
            department: null,
            roomNo: null,
            errors: {
                classroomError: null
            },
            first_section: null,
            second_section: null,
            third_section: null,
            panel: false,
            showDeleteConfirmationDialog:false,
            subjects: [],
            toDeleteSubject:null,
            faculty: [],
            classroom: {
                room_no: null,
            },
        }
    },
  methods: {
    ...mapActions(
      [
        "setLoading",
        "setTokens",
        "setCurrentUser",
        "setCurrentInstitution",
        "setFeeSessionData",
        "clearTokens"
      ]
    ),

    async handleApiErrors(err) {
        this.setLoading(false);
        console.log(err);
        if (err.response) {
            if (err.response.status == 409) {
            this.snackbar.message = err.response.data;
            this.snackbar.color = "error";
            this.snackbar.visible = true;
            }
        } else {
            this.snackbar.message = "Unable to process request";
            this.snackbar.color = "error";
            this.snackbar.visible = true;
        }
    },

    async getSectionCategories(){
        var url = endpoints.sectionCategories;
        var response = await api.handleApi({
            apiEssentials: this.apiEssentials,
            url: url,
            responseVar: response,
        });
        if(response){
            this.sectionCategories = response;
            if(this.sectionCategories.find(x => x.type==1)){
                this.sectionFormat = 1; // Standard Division
            }
            else if(this.sectionCategories.find(x => x.type==3)){
                this.sectionFormat = 2; // Batch
            }
            else if(this.sectionCategories.find(x => x.type==4)){
                this.sectionFormat = 3; // Year Department Division
            }
        }
    },
    
    async getSections(){
        var url = endpoints.getSections;
        var response = await api.handleApi({
            apiEssentials: this.apiEssentials,
            url: url,
            responseVar: response,
        });
        if(response){
            this.sections = response;
        }
    },

    async checkClassroomExists(){
        if(this.sectionFormat == 1){
            if(this.standard && this.division){
                
                if(this.standard != null && this.standard.constructor.name === "Object")
                    this.first_section = this.standard
                else
                    this.first_section = {
                        title: this.standard,
                        section_class: 1,
                        section_category: this.sectionCategories.find(x => x.type==1),
                    }

                if(this.division != null && this.division.constructor.name === "Object")
                    this.second_section = this.division
                else
                    this.second_section = {
                        title: this.division,
                        section_class: 2,
                        section_category: this.sectionCategories.find(x => x.type==2),
                    }

            }else{
                return;
            }
        }
        else if(this.sectionFormat == 2){
            if(this.batch){

                if(Object.keys(this.batch).length)
                    this.first_section = this.batch
                else
                    this.first_section = {
                        title: this.batch,
                        section_class: 1,
                        section_category: this.sectionCategories.find(x => x.type==3),
                    }

            }else{
                return;
            }
        }
        else if(this.sectionFormat == 3){
            if(this.year && this.department && this.division){
                
                if(Object.keys(this.batch).length)
                    this.first_section = this.year
                else
                    this.first_section = {
                        title: this.year,
                        section_class: 4,
                        section_category: this.sectionCategories.find(x => x.type==4),
                    }
                
                if(Object.keys(this.batch).length)
                    this.second_section = this.year
                else
                    this.second_section = {
                        title: this.department,
                        section_class: 5,
                        section_category: this.sectionCategories.find(x => x.type==5),
                    }
                
                if(Object.keys(this.batch).length)
                    this.third_section = this.division
                else
                    this.third_section = {
                        title: this.division,
                        section_class: 2,
                        section_category: this.sectionCategories.find(x => x.type==2),
                    }

            }else{
                return;
            }
        }
        var response = await api.handleApi({
            apiEssentials: this.apiEssentials,
            url: endpoints.checkClassroomExists,
            responseVar: response,
            method: api.Methods.POST,
            body: {first_section: this.first_section, second_section: this.second_section, third_section: this.third_section},
        });
        
        if(response){
            this.errors.classroomError = "Classroom already exists!"
        }else{
            this.errors.classroomError = null;
        }
    },

    async addRoom(){

        if(!this.$refs.addEditClassroomForm.validate()) 
          return;

        var post_body = {
            classroom: {
                first_section: this.first_section, 
            },
            room_no: this.classroom.room_no,
            is_editing: this.is_editing,
        }

        if (this.second_section){
            post_body.classroom.second_section = this.second_section
        }

        if (this.third_section){
            post_body.classroom.third_section = this.third_section
        }

        if(this.is_editing){
            post_body.classroom_id = this.classroom.id;
        }

        var response = await api.call(
            this.apiEssentials,
            endpoints.addEditClassRoom,
            api.Methods.POST,
            post_body,
        );
        if(response){
            if(this.is_editing)
            this.snackbar.message="Classroom edited successfully!";
            else{
                this.classroom.id = response.room_id;
                this.snackbar.message = "Classroom Added Successfully!";
            }
            this.snackbar.visible=true;
            this.snackbar.color="success";
            this.submitForm=false;
            setTimeout(()=>{
                this.$router.push({ name:'ClassroomDetails', params: { id: this.classroom.id } })
            }, 1000)
        }
    },

    async getClassRoomDetails(){
        this.setLoading(true);
        var response;
        var url = endpoints.getClassRoomDetails + `${this.classroom.id}/`;
        
        response = await api.handleApi({
            apiEssentials: this.apiEssentials,
            url: url,
            responseVar: response,
        });

            if(response instanceof Error){
            this.setLoading(false);
            this.snackbar.message = "Error retrieving details";
            this.snackbar.visible = true;
            return;
        }
        else{
            this.classroom = response;
            if(this.classroom.first_section.section_class == 1){
                this.standard = this.classroom.first_section
                this.division = this.classroom.second_section
                this.first_section = this.standard
                this.second_section = this.division
            }else if(this.classroom.first_section.section_class == 3){
                this.batch = this.classroom.first_section
                this.first_section = this.batch
            }else if(this.classroom.first_section.section_class == 4){
                this.year = this.classroom.first_section
                this.department = this.classroom.second_section
                this.division = this.classroom.third_section
                this.first_section = this.year
                this.second_section = this.department
                this.third_section = this.division
            }

        }
        this.setLoading(false);
    },

    async getClassRoomSubjects(){
        this.setLoading(true);
        var response;
        var url = endpoints.getClassRoomSubjects + `${this.classroom.id}/`;

        response = await api.handleApi({
            apiEssentials: this.apiEssentials,
            url: url,
            responseVar: response,
        });

            if(response instanceof Error){
            this.setLoading(false);
            this.snackbar.message = "Error retrieving subjects";
            this.snackbar.visible = true;
            return;
        }
        else{
            this.subjects = response;
        }
        this.setLoading(false);
    },

    async getAllFaculty(){
        this.setLoading(true);
        var response;
        var url = endpoints.getAllFaculty;

        response = await api.handleApi({
            apiEssentials: this.apiEssentials,
            url: url,
            responseVar: response,
        });

        if(response instanceof Error){
            this.setLoading(false);
            this.snackbar.message = "Error retrieving faculty";
            this.snackbar.visible = true;
            return;
        }
        else{
            this.faculty = response;
        }
        this.setLoading(false);
    },

    async deleteSubject(subject){
        this.toDeleteSubject = Helper.clone(subject)
        this.showDeleteConfirmationDialog = true
    },

    appendSubject(subject){
        this.subjects.push(subject);
        this.snackbar.message = "Subject successfully added!";
        this.snackbar.visible = true;
    },

    async deleteSelectedClassroom(confirm){
        if(confirm){
            var response;
            console.log(this.toDeleteSubject);
            response = await api.handleApi({
                apiEssentials : this.apiEssentials,
                url: endpoints.deleteSubject,
                responseVar: response,
                method: api.Methods.POST,
                body : { 'subject' :  this.toDeleteSubject},
            })
            if(response){
                var index = this.subjects.indexOf(this.toDeleteSubject);
                this.subjects.splice(index,1);
                this.showDeleteConfirmationDialog = false
            }
        }else{
            this.showDeleteConfirmationDialog = false
        }
    },

  },
  created(){
      this.getSectionCategories();
      this.getSections();
      if(this.$route.params.id){
          this.is_editing=true;
          this.classroom.id = this.$route.params.id;
          this.getClassRoomDetails();
          this.getClassRoomSubjects();
      }
      this.getAllFaculty();
  }
}
</script>

<style scoped>

</style>